import { styled } from '@mui/material';

import { AiResponseExplanation } from '@app-velocity/ui';

import { useSingleAiResponseContext } from '../hooks/useSingleAiResponseContext';

const StyledAiResponseDetails = styled('div')(({ theme }) => ({
  borderRadius: theme.spacing(2),
}));

export const Explanation = () => {
  const { collapsed, response } = useSingleAiResponseContext();

  if (collapsed || !response) return null;

  return (
    <StyledAiResponseDetails>
      <AiResponseExplanation response={response} variant="compact" />
    </StyledAiResponseDetails>
  );
};
